import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { BusinessClassIcon } from '@trello/nachos/icons/business-class';

import * as styles from './PresentationalUpgradePill.module.less';

export const PresentationalUpgradePill: FunctionComponent = () => {
  return (
    <div className={styles.upgradePromptPill}>
      <BusinessClassIcon
        dangerous_className={styles.upgradePromptPillIcon}
        size="small"
      />
      <FormattedMessage
        id="templates.planner.upgrade"
        defaultMessage="Upgrade"
        description="Upgrade prompt pill text"
      />
    </div>
  );
};
